<template>
    <v-data-table 
        :loading="isLoading"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :footer-props="{
            'items-per-page-options': [10, 20, 50, 100]
        }"
        v-bind="$attrs"
        v-on="$listeners"
    >
        <template
            v-for="(_, s) in $scopedSlots"
            #[s]="props"
        > 
            <slot
                :name="s"
                v-bind="props"
            /> 
        </template>
    </v-data-table>
</template>

<script>
import { get } from 'lodash'

export default {
    props: {
        payload: {
            type: Object,
            default: () => ({})
        },
        filters: {
            type: Object,
            default: () => ({})
        },
        request: {
            type: [Function, String],
            required: true
        },
        itemsMapKey: {
            type: String,
            default: 'message'
        },
        totalItemsKey: {
            type: String,
            default: 'meta.total_items'
        },
        metaMapKey: {
            type: String,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            innerLoading: false,
            meta: {},
            total: 0,
            items: [],
            options: {
                itemsPerPage: 10,
            },
        }
    },
    computed: {
        isLoading: {
            get() {
                return this.loading || this.innerLoading
            },
            set(value) {
                this.$emit('update:loading', value)
                this.innerLoading = value
            }
        }
    },
    methods: {
        async getResponse() {
            if (typeof this.request === 'function') {
                return this.request({
                    page: this.options.page,
                    limit: this.options.itemsPerPage,
                    sortBy: this.options.sortBy,
                    sortDesc: this.options.sortDesc,
                    filters: this.filters,
                })
            }

            const method = this.$api[this.request] 

            if (!method) {
                console.error('Method not found', method)

                return {
                    total: 0,
                    meta: {},
                    data: [],
                }
            }

            const response = await method({
                page: this.options.page,
                limit: this.options.itemsPerPage,
                sortBy: this.options.sortBy,
                sortDesc: this.options.sortDesc,
                filters: this.filters,
            })

            if (response.error) {
                return {
                    error: true,
                    total: 0,
                    meta: {},
                    data: [],
                }
            }

            let data = get(response, this.itemsMapKey)
            let total = get(response, this.totalItemsKey, 0)
            let meta = response.meta

            if (this.metaMapKey) {
                meta = get(response, this.metaMapKey)
            }

            return {
                total,
                meta,
                data,
            }
        },
        async load(){
            this.isLoading = true 

            const { data, total, meta } = await this.getResponse()

            if (!Array.isArray(data)) {
                this.isLoading = false
                console.error('Data is not an array', data)
                return
            }

            this.items = data
            this.meta = meta
            this.total = total

            setTimeout(() => {
                this.isLoading = false
            }, 1000)

        },
    },
    watch: {
        options: {
            handler: 'load',
            deep: true
        },
        filters: {
            deep: true,
            handler(){
                this.options = {
                    ...this.options,
                    page: 1
                }
            }
        }
    }
}
</script>